<template>
    <item-list
        :items="items"
        :data-table-config="dataTableConfig"
        :actions="actions"
        :tooltips="tooltips"
        show-actions
        header="Turniere"
    ></item-list>
</template>

<script>
    import { mapState } from 'vuex';
    import ItemList from '../common/ItemList';

    export default {
        components: {
            'item-list': ItemList
        },
        data() {
            return {
                items: {
                    loaded: false,
                    items: []
                },
                dataTableConfig: {
                    loadingDataText: 'Lade Turniere',
                    noDataText: 'Keine Turniere verfügbar',
                    rowsPerPageText: 'Zeilen pro Seite',
                    headers: [
                        { text: this.$t('date'), value: 'start', align: 'left' },
                        { text: this.$t('fake_register_end'), value: 'fake_register_end', align: 'left' },
                        { text: this.$t('event_name'), value: 'name', align: 'left' },
                        { text: this.$t('town'), value: 'town', align: 'left' },
                        //{ text: this.$t('event_type'), value: 'town', align: 'left' },
                        { text: this.$t('first_price'), value: 'current_price.price_string', align: 'left' },
                        { text: this.$t('price_reduced'), value: 'current_price.price_reduced_string', align: 'left' }
                    ],
                    items: {
                        large: [
                            { value: 'start', formatFunction: '$formatDate', class: 'text-xs-left' },
                            { value: 'fake_register_end', formatFunction: '$formatDate', class: 'text-xs-left' },
                            { value: 'name', class: 'text-xs-left' },
                            { value: 'town', class: 'text-xs-left' },
                            { value: 'current_price.price_string', class: 'text-xs-left' },
                            { value: 'current_price.price_reduced_string', class: 'text-xs-left' }
                        ],
                        small: [
                            { value: 'name' }
                        ]
                    }
                },
                actions: [
                    {
                        visible: event => {
                            return _.some(this.starters.items, s => s.event_id === event.id);
                        },
                        label: this.$t('unregister_all_starters'),
                        icon: 'clear',
                        click: event => {
                            this.$store.commit('confirm', {
                                headline: 'Offene Meldungen wirklich entfernen?',
                                text: this.$t('questions.unregister_all_starters', [event.name]),
                                callback: () => {
                                    axios.delete('/api/v1/starters/delete', {
                                        params: {
                                            event_id: event.id
                                        }
                                    }).then(response => {
                                        if (!response.data.success) {
                                            return;
                                        }

                                        this.$store.dispatch('loadStarters');
                                    });
                                }
                            });
                        }
                    },
                    {
                        visible: event => (this.$hasRole('admin') || !event.is_locked),
                        label: this.$t('register_starter'),
                        icon: 'input',
                        click: item => {
                            this.$router.push(`/user/event-registration/${item.id}`);
                        }
                    },
                    {
                        visible: event => !this.$hasRole('admin') && event.is_locked,
                        disabled: event => true,
                        label: this.$t('registration_ended'),
                        icon: 'input',
                        click: item => {
                        }
                    }
                ],
                tooltips: [
                ]
            }
        },
        computed: mapState(['events', 'starterTemplates', 'starters']),
        watch: {
            events: {
                deep: true,
                handler() {
                    this.updateEvents();
                }
            }
        },
        mounted() {
            this.updateEvents();
        },
        methods: {
            updateEvents() {
                this.$set(this.items, 'items', []);
                this.$set(this.items, 'loaded', this.events.loaded);

                _.each(this.events.items, e => {
                    if (this.$hasRole('admin')) {
                        if (!e.is_over) {
                            this.items.items.push(e);
                        }
                    } else {
                        if (!e.is_locked) {
                            this.items.items.push(e);
                        }
                    }
                });
            }
        }
    }
</script>
